import { useMutation, useQueryClient } from "@tanstack/react-query";

import API from "../../api/API";
import { getErrorMessage } from "../../../utils/GeneralUtils";
import { newToastEvent } from "../../../utils/ToastUtil";

/**
 * For logging in as any user in Crititcal situations
 * Only works for Supportal users
 */
export default function useEnableDisableAccount() {
  const client = useQueryClient();

  const accountStatus = useMutation({
    mutationFn: ({
      userID,
    }: {
      userID: string;
      accountStatus: boolean;
      onSuccess?: () => void;
      onError?: () => void;
    }) => {
      return API.enableDisableAccount(userID);
    },
    onSuccess: (_, { userID, accountStatus, onSuccess }) => {
      client.refetchQueries({ queryKey: ["person", userID], type: "all" });
      newToastEvent(
        "success",
        `Successfully ${accountStatus ? "Disabled" : "Enabled"} account.`
      );

      onSuccess && onSuccess();
    },
    onError: (error, { onError }) => {
      const errorMessage = getErrorMessage(
        error,
        "An unknown error occurred. Please try again."
      );

      newToastEvent("error", errorMessage);

      onError && onError();
    },
  });

  return {
    modifyAccountStatus: accountStatus.mutate,
  };
}
